import EnterpriseRepository from '@/shared/http/repositories/realestate/enterprise'
import FileEnterpriseRepository from '@/shared/http/repositories/realestate/fileenterprise'
import semImagem from '../../../../../../../static/img/survey/sem-foto.png'

import { loading } from '@/shared/utils/UIHelper'
export default {
  props: ['data'],
  name: 'Panelenterprise',
  data () {
    return {
      dataFixDetail: {
        nome: '',
        cidade: '',
        bairro: '',
        cep: '',
        tamanho: '',
        status: '',
        foto: '',
        endereco: ''
      },
      foto: '',
      dataEnum: [],
      semImagem: semImagem
    }
  },
  mounted () {
    this.dataFix()
    this.getAllStatus()
    this.getLogo()
  },
  methods: {
    dataFix () {
      this.dataFixDetail.nome = this.data.nome
      this.dataFixDetail.endereco = this.data.endereco
      this.dataFixDetail.cidade = this.data.cidade
      this.dataFixDetail.cep = this.data.cep
      this.dataFixDetail.tamanho = this.data.tamanho
      this.dataFixDetail.foto = this.data.foto
      this.dataFixDetail.bairro = this.data.bairro
    },
    getAllStatus () {
      loading.push()
      EnterpriseRepository.GetEnum()
        .then(Response => {
          this.dataEnum = Response.data
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    getEnumDescription (en) {
      if (this.dataEnum.length > 0) {
        return this.dataEnum.find((Element) => Element.enum === en).descricao
      }
    },
    getLogo () {
      loading.push()
      FileEnterpriseRepository.GetLogoByEmpreendimentoId(this.data.id)
        .then(Response => {
          loading.pop()
          this.foto = Response.data
        })
        .catch(Error => {
          loading.pop()
        })
    }
  }

}



// WEBPACK FOOTER //
// ./src/views/private/realestate/enterprise/components/panelenterprise/panelenterprise.js